<template>
  <div id="app">
    <router-view name="navbar"></router-view>
    <router-view></router-view>
    <router-view name="footer"></router-view>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
/* @import url('https://fonts.googleapis.com/css?family=Muli:200,200i,300,300i,400,400i,600,600i,700,700i,800,800i,900,900i&subset=latin-ext'); */
@import url('https://fonts.googleapis.com/css?family=Satisfy');
@import url('https://fonts.googleapis.com/css?family=Work+Sans:100,200,300,400,500,600,700,800');

#app {
  /*font-family: 'Avenir', Helvetica, Arial, sans-serif;*/
  font-family: 'Muli', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  /* text-align: center; */
  color: #2c3e50;
  /* margin-top: 60px; */
}

.page-item.active a {
  background-color: yellow;
}

.disabled a {
  color: #000 !important;
}
.theme-pannel-main{
  display: none;
}

#markerLayer img {
  border: 1px solid white !important;
  border-radius: 100px;
}
@font-face {
  font-family: "kalpurush";
  src: local("kalpurush"),
   url(./fonts/kalpurush.ttf) format("truetype");
}
@font-face {
  font-family: "mermaid";
  src: local("mermaid"),
   url(./fonts/Mermaid_Swash_Caps.ttf) format("truetype");
}
@font-face {
  font-family: "Times New Roman";
  src: local("Times New Roman"),
   url(./fonts/times_new_roman.ttf) format("truetype");
}
</style>
